import React from 'react';
import {
  FormControl,
  FormLabel,
} from '@alefeducation/ui-elements-library-core';
import styled from 'styled-components';
import { disableInput, DisableInputType } from '../../../styles/Common';

interface TCProps extends DisableInputType {
  title: string;
  children: React.ReactNode;
}

const StyledFormControl = styled(FormControl)`
  ${disableInput}
`;

const FormControlContainer = ({ title, children, ...restProps }: TCProps) => {
  return (
    <StyledFormControl {...restProps}>
      <FormLabel>{title}</FormLabel>
      {children}
    </StyledFormControl>
  );
};

export default FormControlContainer;
